<template>
	<div class="Login">
		<Protocol v-if="showProtocol" @isShowProtocol="handleIsShowProtocol"></Protocol>
		<div v-else>
			<div class="toLogin" @click="toRouter('/login_new')">账号登录</div>
			<div class="LoginMethod">
				<div v-if="regMethods.includes('handset')" @click="SwitchingMethod('handset')" class="Method fl" :class="{ highlight: wayToRegister }">
					手机号注册<span v-show="wayToRegister"></span>
				</div>

				<div v-if="regMethods.length == 2" class="fl cutApart"></div>

				<div v-if="regMethods.includes('mailbox')" @click="SwitchingMethod('mailbox')" class="Method fl" :class="{ highlight: !wayToRegister }">
					邮箱注册<span v-show="!wayToRegister"></span>
				</div>

				<div class="clear"></div>
			</div>
			<div class="EditingArea">
				<div v-show="wayToRegister" class="vanField">
					<ul>
						<li>
							<van-field v-model="phone" center clearable :border="false" placeholder="请输入手机号" />
						</li>
						<li class="authcodeInputWrapper">
							<van-field v-model="Verification" class="VerificationStyle fl" center clearable placeholder="请输入验证码" :border="false" />

							<div
								class="getVerificationStyle fr"
								@click="postAccountGetAuthCode('phone')"
								:style="{ color: Countdown1 > 0 ? '#BBBBBB' : '#333333' }"
							>
								{{ VerificationStatus }}
							</div>

							<div class="clear"></div>
						</li>
						<li class="passwordInputWrapper">
							<van-field
								class="passwordStyle fl"
								v-model="password"
								center
								clearable
								:type="passwordType1"
								placeholder="设置8至20位登录密码"
								:border="false"
							/>

							<div class="VisibleCutApart fl"></div>

							<div class="Visible fr" @click="setVisible('password')">
								<img class="fl" :src="isVisibleImg" alt="" />
							</div>
						</li>
						<li class="passwordInputWrapper">
							<van-field
								class="passwordStyle fl"
								v-model="password2"
								center
								clearable
								:type="passwordType2"
								@blur="inputBlur"
								placeholder="请再次输入登录密码"
								:border="false"
							/>

							<div class="VisibleCutApart fl"></div>

							<div class="Visible fr" @click="setVisible('rePassword')">
								<img class="fl" :src="isVisibleImg2" alt="" />
							</div>
						</li>
					</ul>
				</div>
				<div v-show="!wayToRegister" class="vanField">
					<ul>
						<li>
							<van-field v-model="phone" center clearable :border="false" placeholder="请输入邮箱" />
						</li>
						<li class="authcodeInputWrapper">
							<van-field v-model="Verification" class="VerificationStyle fl" clearable placeholder="请输入验证码" :border="false" />

							<div
								class="getVerificationStyle fr"
								@click="postAccountGetAuthCode('mail')"
								:style="{ color: Countdown2 > 0 ? '#BBBBBB' : '#333333' }"
							>
								{{ VerificationStatus }}
							</div>

							<div class="clear"></div>
						</li>
						<li class="passwordInputWrapper">
							<van-field
								class="passwordStyle fl"
								v-model="password"
								clearable
								:type="passwordType1"
								placeholder="设置8至20位登录密码"
								:border="false"
							/>

							<div class="VisibleCutApart fl"></div>

							<div class="Visible fr" @click="setVisible('password')">
								<img class="fl" :src="isVisibleImg" alt="" />
							</div>
						</li>
						<li class="passwordInputWrapper">
							<van-field
								class="passwordStyle fl"
								v-model="password2"
								clearable
								:type="passwordType2"
								@blur="inputBlur"
								placeholder="请再次输入登录密码"
								:border="false"
							/>

							<div class="VisibleCutApart fl"></div>

							<div class="Visible fr" @click="setVisible('rePassword')">
								<img class="fl" :src="isVisibleImg2" alt="" />
							</div>
						</li>
					</ul>
				</div>
			</div>
			<div class="OperatingSpace">
				<div class="protocolStyle">
					<van-checkbox class="fl" v-model="protocol" label-disabled></van-checkbox>
					<span class="fl" @click="ClearanceAgreement">我同意</span>
					<a class="fl" @click="goPage('service-agreement')">《用户协议》</a>
					<span class="fl">及</span>
					<a class="fl" @click="goPage('privacy')">《法律声明及隐私政策》</a>
					<div class="clear"></div>
				</div>
				<van-button round type="info" @click="toRegist" :class="phone && protocol ? 'van-button--info' : 'noneVanButton'">注册</van-button>
			</div>
		</div>
	</div>
</template>
<script>
import config from '../../../config/url'
import protocol from '../../account/page/protocol'
import yincang from '../../../assets/images/account/icon-yincang.png'
import xianshi from '../../../assets/images/account/icon-xianshi.png'
import { isPhone, isEmail, passReg } from '../../../utils/validate'
export default {
	name: 'registered',
	data() {
		return {
			showProtocol: false,
			protocol: true,
			phone: null,
			password: null,
			password2: null,
			Verification: null,
			Countdown1: 0,
			Countdown2: 0,
			passwordType1: 'password',
			passwordType2: 'password',
			clientHeight: 0,
			place: 'handset',
			theme: '',
			regMethods: ['handset'],
            // regMethods: ['handset', 'mailbox'],
            mobile_prefix: '86',
		}
	},
	components: {
		Protocol: protocol,
	},
	computed: {
		wayToRegister() {
			return this.place === 'handset'
		},
		VerificationStatus() {
			if (this.place === 'handset') {
				if (this.Countdown1) {
					return `重新获取 ${this.Countdown1}s`
				} else {
					return '发送验证码'
				}
			} else {
				if (this.Countdown2) {
					return `重新获取 ${this.Countdown2}s`
				} else {
					return '发送验证码'
				}
			}
		},
		isVisibleImg() {
			return this.passwordType1 === 'password' ? yincang : xianshi
		},
		isVisibleImg2() {
			return this.passwordType2 === 'password' ? yincang : xianshi
        },
        saasUcode() {
			let pageSetData = this.$store.state.dynamic.pageSetData
			return pageSetData && pageSetData.solutionInfo && pageSetData.solutionInfo.saasUcode
		},
	},
	created() {
		// localStorage.clear();
		// this.initConfig()
	},
	mounted() {
		this.clientHeight = document.documentElement.clientHeight
		this.theme = sessionStorage.getItem('theme')
	},
	methods: {
		//   用户协议跳转页面
		goPage(url) {
			this.$router.push(url)
		},
		initConfig() {
			/* 
            手机号+验证码 is_allow_telephone_register 
            手机号+密码   is_allow_email_register 
        */
			let frontendConfig = this.$store.state.dynamic.frontendConfig || []
			frontendConfig.length &&
				frontendConfig.forEach((item) => {
					switch (item.key) {
						case 'is_allow_telephone_register':
							if (item.value === 'false') {
								let index = this.regMethods.findIndex((item) => {
									return item === 'handset'
								})
								this.regMethods.splice(index, 1)
							}
							break
						case 'is_allow_email_register':
							if (item.value === 'false') {
								let index = this.regMethods.findIndex((item) => {
									return item === 'mailbox'
								})
								this.regMethods.splice(index, 1)
							}
							break
						default:
							break
					}
				})
			this.place = this.regMethods[0]
		},
		handleIsShowProtocol(data) {
			this.showProtocol = data
		},
		setVisible(type) {
			if (type === 'rePassword') {
				if (this.passwordType2 === 'password') {
					this.passwordType2 = 'text'
					return false
				}
				this.passwordType2 = 'password'
			} else {
				if (this.passwordType1 === 'password') {
					this.passwordType1 = 'text'
					return false
				}
				this.passwordType1 = 'password'
			}
		},
		async toRegist() {
			if (!this.protocol) return
			if (!passReg.test(this.password)) {
				this.$notify({ type: 'warning', message: '请设置8-20位，数字、大小写字母、字符组合密码' })
				return
			}
			if (!this.inputBlur()) return
			const data = {
				authCode: this.Verification,
                password: this.password,
                areaCode: this.mobile_prefix,
                saasUcode: this.saasUcode
            }
            console.log('saasucode---------------',this.saasUcode)
			if (this.wayToRegister) {
				data.phone = this.phone
			} else {
				data.mail = this.phone
			}

			this.$api.account_new.register(data).then((res) => {
				if (res.success) {
					this.$toast({
						message: '恭喜你，注册成功',
					})
					this.$router.replace('/login_new')
				}
			})
		},
		getUserInfo() {
			this.$api.usercenter.getAccountUserInfo({}).then((res) => {
				localStorage.setItem('WDuserInfo', JSON.stringify(res.data))
				this.$store.commit('setUserInfo', res.data)
			})
		},
		// 查询用户id
		findUserId() {
			this.$api.usercenter.findUser().then((res) => {
				if (res.code == 0) {
					let subUser = { id: res.data.id }
					localStorage.setItem('subUserInfo', JSON.stringify(subUser))
				}
			})
		},
		inputBlur() {
			let result = true
			if (!this.password || !this.password2) {
				result = false
			}
			if (this.password && this.password2 && this.password !== this.password2) {
				this.$notify({ type: 'warning', message: '两次密码输入不一致，请重新输入' })
				result = false
			}
			return result
		},
		toRouter(path) {
			this.$router.push({ path })
		},
		ClearanceAgreement() {
			this.protocol = !this.protocol
		},
		SwitchingMethod(val) {
			this.place = val
			// this.protocol= false;
			this.phone = null
			this.password = null
			this.password2 = null
			this.Verification = null
			this.passwordType1 = 'password'
			this.passwordType2 = 'password'
		},
		setCountdown1() {
			let Countdown = null
			Countdown = setInterval(() => {
				this.Countdown1--
				if (this.Countdown1 <= 0) {
					clearInterval(Countdown)
				}
			}, 1000)
		},
		setCountdown2() {
			let Countdown = null
			Countdown = setInterval(() => {
				this.Countdown2--
				if (this.Countdown2 <= 0) {
					clearInterval(Countdown)
				}
			}, 1000)
		},
		postAccountGetAuthCode(type) {
			let CountdownType = 'Countdown1'
			if (!this.wayToRegister) {
				CountdownType = 'Countdown2'
			}
			if (this[CountdownType] > 0) return
			if (isPhone.test(this.phone) || isEmail.test(this.phone)) {
				if (type === 'phone') {
					this.Countdown1 = 60
					this.setCountdown1()
					this.$api.account_new.getPhoneAuthCode4Register({ phone: this.phone, areaCode: this.mobile_prefix })
				} else {
					// this.Countdown2 = 60
					// this.setCountdown2()
					// this.getAuthCode()
				}
			} else {
				let account = this.place === 'handset' ? '手机号' : '邮箱账号'
				this.$toast({ type: 'warning', message: account + '格式有误,请检查一下吧' })
			}
		},
	},
}
</script>
<style lang="stylus" scoped>
@import './css/register.styl'
</style>
